import React from "react";
import { TimezoneSettings } from "./TimezoneSettings";
import { ThemeSettings } from "./ThemeSettings";

export function PreferencesSettings() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-4">Preferences</h2>
        <p className="text-muted-foreground">
          Customize your application experience
        </p>
      </div>

      <div className="border-b pb-6">
        <ThemeSettings />
      </div>

      <TimezoneSettings />
    </div>
  );
}